<app-home-header></app-home-header>
<div class="agent-container">
  <div class="dashboard-container" [@routeAnimations]="getRouteAnimationData()">
    <router-outlet></router-outlet>
  </div>
  <div class="appointment-list-container">
    <app-appointment-list></app-appointment-list>
  </div>
</div>
